module.exports = __webpack_public_path__ + "assets/img/tool_qrcode.001b4e94.png";